import React from 'react'
import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, } from '@mui/material'
import moment from 'moment/moment'

const DispatchMiddSection3 = ({
  loginData,
  reportType,
  showSummaryReport,
  detailedFilter,
  selFromBranch,
  selDestCity,
  selBranch,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
  groupDataSecond,
}) => {
  const SecontInsideRowContentSummary = ({ item, index,fontVal }) => {
    return (
      <>
        <TableRow>
          {Object.keys(item).length == 21 ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={3}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                  height:'36px'
                }}
              >
                {item.SummaryToCity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.topayCount.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.paidCount.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.onAccountCount.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.focCount.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.topaydddvCount.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.total.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalQuantity}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.ToPayCodFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.paidFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.OnAccountFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.FocFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.DddvFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.ToPayCodGstOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.paidGstOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.OnAccountGstOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.FocGstOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.TopayDddvGstOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalGstOther.toFixed(2)}
              </TableCell>
              {reportType?.Name === 'Cancel Dispatch' ? (
                <>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                  >
                    {item.totalNetAmount.toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                  >
                    
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                  >
                  </TableCell>
                </>
              ) : (
                <>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                >
                  {item.totalNetAmount.toFixed(2)}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                >
                  {/* {item.totalNetAmount} */}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                >
                  {/* {item.totalNetAmount} */}
                </TableCell>
                </>
              )}
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'left',
                }}
              >
                {item.VehicleNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left',
                }}
              >
                {item.SummaryFromCity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'left',
                }}
              >
                {item.SummaryToCity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.topayCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.paidCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.onAccountCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.focCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.topaydddvCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.total}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalQuantity}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalToPayCodFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalpaidFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalOnAccountFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalFocFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalDddvFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalToPayCodGstOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalpaidGstOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalOnAccountGstOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalFocGstOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalTopayDddvGstOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalGstOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'right',
                }}
              >
                {item.totalNetAmount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'left',
                }}
              >
                {item.DispatchDateTime}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '100px',
                }}
              >
                <Tooltip title={item.SummaryDriverConductorName} placement="top-start">
                <span>{item.SummaryDriverConductorName}</span>
                </Tooltip>
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
        <TableContainer className="scrollBlue" sx={{"&::-webkit-scrollbar": {width:'6px',height:'6px'},border:'1px solid #aeaeae','& .MuiTableCell-root': {
            fontSize: '14px !important'
        }}} component={Paper}>
          <Table className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'left', color: '#444444',height:'36px',backgroundColor: '#bfe1ff' }}
                  colSpan={8}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'left', color: '#444444',backgroundColor: '#bfe1ff' }}
                  colSpan={8}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'left', color: '#444444',backgroundColor: '#bfe1ff' }}
                  colSpan={9}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'left ',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Vehicle <br />
                  No.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Dispatch <br />
                  City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Receiving <br />
                  City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ToPay + <br />
                  COD LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  PAID <br /> LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ON Account <br />
                  LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC +<br /> Self LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  DDDV <br /> LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL <br />
                  LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL <br />
                  UNITS
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ToPay +<br /> COD Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  PAID <br /> Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ON Account <br />
                  Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC +<br /> Self Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  DDDV <br /> Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL <br />
                  FREIGHT
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ToPay +<br /> COD GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  PAID <br /> GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ON Account <br /> GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC + Self <br /> GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  DDDV <br /> GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL <br />
                  GST+OTH
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL
                  <br /> NET AMT.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Dispatch
                  <br /> Date & Time
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Driver
                  <br /> Name
                </TableCell>
              </TableRow>
            </TableHead>
            {groupDataSecond?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={25}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : groupDataSecond?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {groupDataSecond?.map((item, index) => (
                  <SecontInsideRowContentSummary item={item} index={index} key={index} fontVal={'12px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
          <Table style={{display:'none'}} id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
          <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={12}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'right' }}
                  colSpan={13}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={25}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  From Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  To Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={4}
                >
                  dispatch By Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={4}
                >
                  Destination City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={3}
                >
                  DestinationBranch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Vehicle Number
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report View
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report Option
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={4}
                >
                  <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={4}
                >
                  <span>{selDestCity?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{selBranch?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selVehicle?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selPaymentTpe?.name || 'All'}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{reportType?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{showSummaryReport?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{detailedFilter?.Name} </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={25}></TableCell>
              </TableRow>
            </TableHead>
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'left', color: '#444444',height:'36px',backgroundColor: '#bfe1ff' }}
                  colSpan={8}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'left', color: '#444444',backgroundColor: '#bfe1ff' }}
                  colSpan={8}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'left', color: '#444444',backgroundColor: '#bfe1ff' }}
                  colSpan={9}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'left ',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Vehicle <br />
                  No.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Dispatch <br />
                  City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Receiving <br />
                  City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ToPay + <br />
                  COD LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  PAID <br /> LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ON Account <br />
                  LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC +<br /> Self LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  DDDV <br /> LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL <br />
                  LRs
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL <br />
                  UNITS
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ToPay +<br /> COD Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  PAID <br /> Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ON Account <br />
                  Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC +<br /> Self Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  DDDV <br /> Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL <br />
                  FREIGHT
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ToPay +<br /> COD GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  PAID <br /> GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  ON Account <br /> GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC + Self <br /> GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  DDDV <br /> GST+Other
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL <br />
                  GST+OTH
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  TOTAL
                  <br /> NET AMT.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Dispatch
                  <br /> Date & Time
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Driver
                  <br /> Name
                </TableCell>
              </TableRow>
            </TableHead>
            {groupDataSecond?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={25}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '20px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : groupDataSecond?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '20px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {groupDataSecond?.map((item, index) => (
                  <SecontInsideRowContentSummary item={item} index={index} key={index} fontVal={'20px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default DispatchMiddSection3
